"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendVisibleTableColumns = exports.trimHiddenTableColumns = void 0;
const table_preferences_1 = require("../enums/table-preferences");
const trimHiddenTableColumns = (columns) => {
    const visibleCount = columns.filter((column) => column.isVisible).length;
    const hiddenKeys = new Set(columns
        .filter((column) => !column.isVisible)
        .slice(0, Math.max(0, table_preferences_1.MAX_TABLE_COLUMNS - visibleCount))
        .map((column) => column.key));
    return columns.filter((column) => column.isVisible || hiddenKeys.has(column.key));
};
exports.trimHiddenTableColumns = trimHiddenTableColumns;
// A trimmed list is full, so a column it dropped is never shown again as a new one.
const appendVisibleTableColumns = (columns, keys) => {
    const listedKeys = new Set(columns.map((column) => column.key));
    const newColumns = keys
        .filter((key) => !listedKeys.has(key))
        .slice(0, Math.max(0, table_preferences_1.MAX_TABLE_COLUMNS - columns.length))
        .map((key) => ({ key, isVisible: true }));
    return [...columns, ...newColumns];
};
exports.appendVisibleTableColumns = appendVisibleTableColumns;
